<div class="fixed-top custombg" style=" z-index: 100;">
  <div class="d-flex flex-column">
      <app-header #header></app-header>
      <app-breadcrumb></app-breadcrumb>
  </div>
</div>
<div class="main-body mt-5">   
    <div class="example-container d-flex flex-column w-100">         
      <div class="table-title w-100">
          <span>Search Project(s)</span>
      </div> 
      <div class="data-filter-container w-100">
        <form [formGroup]="projectSearchForm" class=" w-100">          
          <table class="search-table w-100">
              <tr>
                  <td><label>Project</label></td>
                  <td><input type="text" class="form-control" formControlName="projectName"></td>
                  
                  <td class="separator">&nbsp;</td>
                  <td><label>Delivery Manager</label></td>
                  <td>                        
                      <select class="form-control" formControlName="deliveryManager">
                        <option disabled selected value=-1>-- All --</option>
                        <option *ngFor="let option of deliveryManagers" [value]="option.userId">{{option.userName}}</option> 
                    </select>
                  </td>
              </tr>
              <tr>
                  <td><label>Start Date</label></td>
                  <td><input type="date" class="form-control" formControlName="startDate"></td>

                  <td class="separator">&nbsp;</td>
                  
                  <td><label>End Date</label></td>
                  <td><input type="date" class="form-control" formControlName="endDate"></td>
              </tr>              
              <tr>
                  <td colspan="4"></td>
                  <td>
                      <div class="example-button-row w-100">
                          <button (click)="resetFormData()" mat-stroked-button color="basic">Clear</button>
                          <button type="submit" (click)="searchProjects()" [disabled]="!isFormValid" mat-stroked-button color="primary">Search</button>
                      </div>                        
                  </td>
              </tr>
          </table>
        </form>
      </div>
      <div class="table-container project-listing-table  d-flex row justify-content-center w-100">
          <mat-table [dataSource]="tableDataSource" matSort class="p-0">

              <!-- Column: Id -->
              <ng-container matColumnDef="auditId" >
                <mat-header-cell *matHeaderCellDef mat-sort-header> Audit ID(Hidden)</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.auditId}} </mat-cell>
              </ng-container>
          
              <!-- Column: Name -->
              <ng-container matColumnDef="projectName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.projectName}} </mat-cell>
              </ng-container>

              <!-- Column: Name -->
              <ng-container matColumnDef="technologyStack">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Technology </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.technologyStack}} </mat-cell>
              </ng-container>
          
              <!-- Column: Manager -->
              <ng-container matColumnDef="managerName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Manager </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{(row.managerName)?row.managerName:'NA'}} </mat-cell>
              </ng-container>

               <!-- Column: Start Date -->
               <ng-container matColumnDef="startDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Start Date </mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{row.startDate | date: 'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                <!-- Column: End Date -->
               <ng-container matColumnDef="endDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> End Date </mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{row.endDate | date: 'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                 <!-- Column: Last Audit Date -->
               <ng-container matColumnDef="lastAuditDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Last Audit</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{row.lastAuditDate}} </mat-cell>
                </ng-container>

                <!-- Column: Audit Frequency -->
                <ng-container matColumnDef="auditFrequency">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Audit Freq </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                      <select [(ngModel)] = "row.auditFrequency" class="form-control">
                          <option disabled selected value=0>-- Select --</option>
                          <option *ngFor="let option of auditFreqOptions" [value]="option.id">{{option.description}}</option> 
                      </select>
                  </mat-cell>
                  
                </ng-container>

                <!-- Column: Audited By -->
                <ng-container matColumnDef="auditorName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Audited By </mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{row.auditorName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
                  <mat-cell *matCellDef="let row" >
                      <button mat-stroked-button (click)="navigateToProjectOverview(row.auditId)">Component</button>
                      <button mat-stroked-button class="ml-2" (click)="editProject(row.auditId)">Edit</button>
                  </mat-cell>
                </ng-container>
          
              <mat-header-row *matHeaderRowDef="tableColumns" class="table-header"></mat-header-row>
              <mat-row *matRowDef="let row; columns: tableColumns;"></mat-row>
            </mat-table>

            <mat-paginator [length]="totalRecordCount"
                           [pageSize]="5"
                           [pageSizeOptions]="[5,10, 25, 50]"
                           aria-label="Select page" *ngIf="projectInfos?.length > 0">
            </mat-paginator>              
      </div>       
    </div>  
    <div class="text-right" *ngIf="hasAuditorRole">
      <button class="custom_button mt-2" routerLink="/Auditor Detail">Create Project</button>
    </div>
</div>